// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesSection_categories__3XZ-p {
  margin-top: 6rem;
}

.CategoriesSection_categories__header__iABhA {
  font-size: var(--text-xl);
  font-weight: 700;
  line-height: 3.2rem;
  color: #000;
  margin-bottom: 3.8rem;
}

.CategoriesSection_categories__list__CotyZ {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  gap: 2rem;
}

.CategoriesSection_categories__list-item__Zzl-4 {
  flex: 0 0 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.CategoriesSection_categories__link__gyWDO {
  width: 9rem;
  height: 9rem;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.CategoriesSection_categories__category-img__xjbMS {
  object-fit: contain;
  max-width: 70%;
  max-height: 70%;
}

.CategoriesSection_categories__name__wfur3 {
  font-size: var(--text-base);
  font-weight: 700;
  line-height: 2.6rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/CategoriesSection/CategoriesSection.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".categories {\n  margin-top: 6rem;\n}\n\n.categories__header {\n  font-size: var(--text-xl);\n  font-weight: 700;\n  line-height: 3.2rem;\n  color: #000;\n  margin-bottom: 3.8rem;\n}\n\n.categories__list {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.categories__list-item {\n  flex: 0 0 10rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.categories__link {\n  width: 9rem;\n  height: 9rem;\n  border: 2px solid var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.categories__category-img {\n  object-fit: contain;\n  max-width: 70%;\n  max-height: 70%;\n}\n\n.categories__name {\n  font-size: var(--text-base);\n  font-weight: 700;\n  line-height: 2.6rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categories": `CategoriesSection_categories__3XZ-p`,
	"categories__header": `CategoriesSection_categories__header__iABhA`,
	"categories__list": `CategoriesSection_categories__list__CotyZ`,
	"categories__list-item": `CategoriesSection_categories__list-item__Zzl-4`,
	"categories__link": `CategoriesSection_categories__link__gyWDO`,
	"categories__category-img": `CategoriesSection_categories__category-img__xjbMS`,
	"categories__name": `CategoriesSection_categories__name__wfur3`
};
export default ___CSS_LOADER_EXPORT___;
